import memoize from "lodash.memoize";

/**
 * Validates if the sum of line items matches the header net amount within a tolerance.
 *
 * @param {Object} document - The document object containing net_amount and line_items array.
 * @returns {boolean} - Returns true if the totals match within the allowed tolerance, otherwise false.
 */
const validateTotals = memoize(
  (document) => {
    if (!document || !document.line_items) {
      console.log("Invalid document or missing line_items:", document);
      return false; // Invalid if there are no line items
    }

    // Parse net_amount
    const netAmount = parseFloat(document.net_amount || 0);

    // Calculate line items total
    const lineItemsTotal = document.line_items.reduce((total, item) => {
      const quantity = parseFloat(item.quantity || 0);
      const unitPrice = parseFloat(item.unit_price || 0);
      const lineItemTotal = quantity * unitPrice;

      // Log individual line item calculations
      console.log(
        `Line Item: Quantity(${quantity}) * Unit Price(${unitPrice}) = Total(${lineItemTotal})`
      );

      return total + lineItemTotal;
    }, 0);

    // Log calculated values
    console.log(`Net Amount: ${netAmount}, Line Items Total: ${lineItemsTotal}`);

    // Tolerance in cents (0.01 = 1 cent)
    const tolerance = 0.01;
    const difference = Math.abs(netAmount - lineItemsTotal);

    // Log difference and result
    console.log(`Difference: ${difference}, Within Tolerance: ${difference <= tolerance}`);

    return difference <= tolerance;
  },
  (document) => {
    // Generate a cache key based on net_amount and line_items
    return JSON.stringify({
      net_amount: document.net_amount,
      line_items: document.line_items,
    });
  }
);

export default validateTotals;
